/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { CELL_STATUSES, CELL_SUB_STATUSES } from 'common/constants';
import { Label } from 'components';
import { colors } from '@material-ui/core';

const CellStatus = props => {
  const { cell, ...rest } = props;

  const statusColors = {
    INVENTORY_SHELL: colors.blueGrey[600],
    FATP: colors.orange[600],
    RETAIL: colors.green[600],
    RENTAL_DEMO: colors.teal[600],
    DEVELOPMENT: colors.blue[600],
    DISASSEMBLED: colors.grey[500],
    DECOMMISSIONED: colors.grey[600],
    FAULTY: colors.red[600]
  };

  return (
    <div>
      {cell && cell.status && (
        <Label {...rest} color={statusColors[cell.status]}>
          {CELL_STATUSES[cell.status]}
          {cell.subStatus ? ' / ' : ''}
          {CELL_SUB_STATUSES[cell.subStatus]}
        </Label>
      )}
    </div>
  );
};

CellStatus.propTypes = {
  cell: PropTypes.object
};

export default CellStatus;
